import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  FilterRow,
  HeaderFilter,
  LoadPanel,
  Lookup,
  Scrolling,
  SearchPanel,
  Selection,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { projectStatus } from "../../SalesManagement/Payment/data";
import ScheduleVarianceCell from "./ScheduleVarianceCell";

import "./index.css";

const ContractListWrapper = styled.div`
  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
  .dx-button {
    margin: 0 5px;
    float: left;
  }
  #infoButton {
    i {
      font-size: inherit;
    }
  }
  .edit-status-col {
    padding: 0 !important;
  }
  #contractListDataGrid {
    max-width: 99vw;
  }
`;

export default function ReportList(props) {
  const { setCTab, setContrNo, reportTabsRef } = props;

  const [contractListDataSource, setContractListDataSource] = useState(null);
  const [priorityDataSource, setPriorityDataSource] = useState(null);

  useEffect(() => {
    getContractList();

    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/common/codeList?name=Priority&cat=10`
      )
      .then((res) => {
        //  prioCodeListId = res.data.codeListId;

        setPriorityDataSource(res.data.code);
      });
  }, []);

  const getContractList = () => {
    setContractListDataSource(
      new CustomStore({
        key: "contrNo",
        load: async () => {
          try {
            const result = await axios.get(
              `${process.env.REACT_APP_BECCO_API_URL}/api/workR/report`
            );

            // contractListGridRef.current.instance.selectRows(uploadedContrNo);

            console.debug("result", result.data);

            return result.data;
          } catch (error) {
            console.log(error);
          }
        },
        // update: async (key, values) => {
        //   await axios.put(
        //     `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg/${key.contrNo}`,
        //     values
        //   );
        // },
      })
    );
  };

  const cellRenderSprName = (data) => {
    return (
      <div>
        <span>{data.data.sprName}</span>
        <br />
        <span style={{ fontSize: "11px" }}>{data.data.sprEnName}</span>
      </div>
    );
  };

  const cellRender = (data) => {
    return (
      <div
        // className="dx-colorbox-color-result-preview"
        style={{
          backgroundColor: data.data.color,
          left: "13px",
          width: "17px",
          height: "17px",
          border: "1px solid",
          borderColor: "#e0e0e0",
          margin: "0 auto",
        }}
      >
        {/* {data.data.color} */}
      </div>
    );
  };

  const onCellPrepared = (e) => {
    if (e.rowType == "data" && e.column.caption == "Priority") {
      const prioCodeId = e.data.prioCodeId;
      const prioColor = e.data.prioColor;

      if (prioCodeId && prioColor) {
        e.cellElement.style.backgroundColor = prioColor;
      }
    } else if (e.rowType == "header") {
      if (
        e.column.dataField == "time" ||
        e.column.dataField == "workTime" ||
        e.column.dataField == "timeUsage" ||
        e.column.dataField == "scheduleVariance"
      ) {
        e.cellElement.style.backgroundColor = "#8E5671";
        e.cellElement.style.color = "#FFF";
      }
    }
  };

  const onClick = (e) => {
    console.debug("[onClick]");
    console.debug("e", e);

    console.debug("setCTab", setCTab);

    reportTabsRef.current.instance.option("selectedIndex", 1);
    setCTab("reportByProject");
    setContrNo([e.row.key]);
  };

  const calculateDisplayValue = (data) => {
    return (data.workTime / data.time) * 100;
  };

  return (
    <ContractListWrapper>
      <DataGrid
        id="contractListDataGrid"
        dataSource={contractListDataSource}
        keyExpr={"contrNo"}
        showBorders={true}
        showColumnLines={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
        width={"100%"}
        wordWrapEnabled={true}
        allowColumnReordering={true}
        height={"auto"}
        style={{
          maxHeight: `calc(100vh - 260px)`,
          // marginLeft: "10px",
          // marginRight: "10px",
        }}
        onCellPrepared={onCellPrepared}
      >
        <LoadPanel enabled={true} />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <SearchPanel visible={true} />
        <Scrolling mode={"virtual"} showScrollbar={"always"} />
        <Selection mode={"single"} />

        <Column
          dataField={"spr"}
          caption={"Sponsor"}
          width={210}
          dataType={"string"}
          cellRender={cellRenderSprName}
        />
        <Column
          dataField={"projStatusCodeId"}
          caption={"Status"}
          dataType={"string"}
          alignment={"center"}
          width={100}
        >
          <Lookup
            dataSource={projectStatus}
            valueExpr={"codeId"}
            displayExpr={"name"}
          />
        </Column>
        <Column
          dataField={"prioCodeId"}
          alignment={"center"}
          caption={"Priority"}
          // minWidth={110}
          width={100}
          allowEditing={true}
        >
          <Lookup
            dataSource={priorityDataSource}
            displayExpr={"name"}
            valueExpr={"codeId"}
          />
          <HeaderFilter
            dataSource={priorityDataSource?.map(({ codeId, name }) => ({
              text: name,
              value: codeId,
            }))}
            allowSearch={true}
          />
        </Column>
        {/* <Column
          dataField={"color"}
          cellRender={cellRender}
          width={70}
          // editCellComponent={ColorComponent}
          caption=""
          allowFiltering={false}
        /> */}
        <Column
          dataField={"contrNo"}
          caption="Contract No."
          width={150}
          dataType="string"
          alignment={"center"}
          allowEditing={false}
        />
        <Column
          dataField={"name"}
          caption="Project Name"
          allowEditing={false}
          minWidth={390}
        />
        <Column
          dataField={"time"}
          caption={"Time (h)"}
          format={{
            type: "fixedPoint",
            precision: 2,
          }}
          width={140}
        />
        <Column
          dataField={"workTime"}
          caption={"Work Time (h)"}
          format={{
            type: "fixedPoint",
            precision: 2,
          }}
          width={140}
        />
        <Column
          dataField={"timeUsage"}
          caption={"Time Usage (%)"}
          calculateDisplayValue={calculateDisplayValue}
          format={{
            type: "fixedPoint",
            precision: 2,
          }}
          dataType={"number"}
          width={135}
        />
        <Column
          dataField={"scheduleVariance"}
          caption={"Schedule Variance"}
          format={{
            type: "fixedPoint",
            precision: 2,
          }}
          width={190}
          cellRender={ScheduleVarianceCell}
          cssClass={"bullet"}
        />
        <Column
          type={"buttons"}
          buttons={[
            {
              hint: "Report by Project",
              icon: "fa-solid fa-arrow-right",
              onClick: onClick,
            },
          ]}
        />
      </DataGrid>
    </ContractListWrapper>
  );
}
